import styled from '@emotion/styled'
import {
  background, border, color, flexbox, grid, layout, position, space, typography, variant,
} from 'styled-system'

const Box = styled.div`
  display: flex;
  width: 100%;
  ${background}
  ${border}
  ${color}
  ${flexbox}
  ${grid}
  ${layout}
  ${space}
  ${position}
  ${typography}
  ${variant({
    variants: {
      center: {
        alignItems: 'center',
        justifyContent: 'center',
      },
      white: {
        border: '1px solid',
        borderRadius: 5,
        backgroundColor: 'white',
        borderColor: 'lineColor',
      },
      whiteGrey: {
        border: '1px solid',
        borderRadius: 5,
        backgroundColor: 'whiteGrey',
        borderColor: 'lineColor',
      },
    },
  })}
`

export default Box
